import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story13.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story13'
const figure = articleFigure(dir)

export const story13: Article = {
  id: 13,
  slug: 'how-minerals-inside-your-phone-are-reshaping-the-world',
  order: 13,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('cobalt'),
  author: 'Sam Geall',
  // The story spans global supply chains; Kolwezi is its cobalt-mining focal point.
  region: [
    {
      name: 'Kolwezi',
      country: 'Democratic Republic of Congo',
      coordinates: [25.47, -10.72],
      impact: 'geopolitical',
    },
  ],
  impactList: ['geopolitical', 'human', 'environmental'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[1]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[2]] },
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[3]] },
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[4]] },
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[5]] },
    ],
  },
}
